import { AppLogsTable } from '@9b3kuq5phwuk4txw/kiban-react-ui'
import { useMemo } from 'react'
import { createLogColumns } from './components/columns'
import { useInquiryActionLogs } from './hooks/useInquiryActionLogs'

type LogsTabProps = {
  inquiryId: number
}
export function LogsTab({ inquiryId }: LogsTabProps) {
  const { data, isLoading } = useInquiryActionLogs(inquiryId)
  const logs = data?.inquiry_action_logs ?? []
  const columns = useMemo(() => createLogColumns(), [])

  return (
    <AppLogsTable
      data={logs}
      columns={columns}
      isLoading={isLoading}
      pageSize={50}
      emptyMessage='変更履歴はありません'
    />
  )
}
